<template>
  <div class="questionBox">
    <div class="question">
      <div class="question-item">
        <div class="item">
          <label class="label-input">您的姓名：<input placeholder="(请输入)" type="name" v-model.trim="name" id="name"
                                                 class="input"/></label>
          <label class="label-input">您的电话：<input placeholder="(请输入)" type="tel" v-model.trim="mobile" id="tel"
                                                 class="input"/></label>
          <!--                    <mt-field label="您的姓名:" placeholder="(请输入)" type="name" v-model.trim="name" id="name"></mt-field>-->
          <!--                    <mt-field label="您的电话:" placeholder="(请输入)" type="tel" v-model.trim="mobile" id="tel"></mt-field>-->
        </div>
        <div class="item">
          <p class="question-title">您的最高学历</p>
          <div class="item-input-cont">
            <label class="label"><input type="radio" v-model="degree" value="大专以下" id="degree"/> 大专以下</label>
            <label class="label"><input type="radio" v-model="degree" value="大专" id="degree"/> 大专</label>
            <label class="label"><input type="radio" v-model="degree" value="本科" id="degree"/> 本科</label>
            <label class="label"><input type="radio" v-model="degree" value="本科以上" id="degree"/> 本科以上</label>
          </div>
        </div>
        <div class="item">
          <p class="question-title">您的职位</p>
          <div class="item-input-cont">
            <label class="label"><input type="radio" v-model="position" value="董事长" id="position"/> 董事长</label>
            <label class="label"><input type="radio" v-model="position" value="高管" id="position"/> 高管</label>
            <label class="label"><input type="radio" v-model="position" value="合伙人" id="position"/> 合伙人</label>
            <label class="label"><input type="radio" v-model="position" value="其他" id="position"/> 其他</label>
          </div>
        </div>
      </div>
    </div>
    <button class="btn" type="button" @click="applyClick()"
            style="color: rgb(255, 255, 255);background: #e58111;">咨询报名详情
    </button>
    <!-- 手机验证码弹框-->
    <div class="auth-code">
      <mt-popup v-model="authCodeBounced">
        <p style="text-align: right" @click="authCodeClose">X</p>
        <h2>手机验证</h2>
        <span>短信验证码已发送到{{ this.mobile }}</span>
        <div class="code-cont">
          <input class="get-code" type="text" v-model="refereeName" placeholder="请输入验证码"/><span
            class="verification-code">{{ verificationCode }}</span>
        </div>
        <button class="btn" type="button" id="btn" @click="submitData()"
                style="color: rgb(255, 255, 255);background: #26a2ff;width: 100%">确定
        </button>
      </mt-popup>
    </div>
  </div>
</template>
<script>
import {getConversion, getRegisterCode, getVerifyCode, landingPageInsert} from "../../../apis/apis";
import {Toast, Radio} from 'mint-ui';
import Vue, {toRef} from 'vue'

Vue.component(Radio.name, Radio);
export default {
  components: {},
  name: "PubForm",
  data() {
    return {
      authCodeBounced: false, //验证码弹框
      count: '',
      status: true,
      timer: 60,
      refereeName: "",//获取验证码
      verificationCode: "",
      mobile: "", //手机号
      name: "", //姓名
      degree: "", //学位
      position: "", //职位
    }
  },
  methods: {
    //手机验证码弹框关闭
    authCodeClose() {
      this.authCodeBounced = false;
    },
    //获取验证码接口
    async getRegisterCode() {
      try {
        let params = {
          "mobile": this.mobile
        }
        let {
          data
        } = await getRegisterCode(params);
        if (data.code == 1000) {
          if (this.status) {
            this.status = false;
            var count = this.timer;
            this.verificationCode = count + "s后重新获取";
            var timer = setInterval(() => {
              if (count === 0) {
                clearInterval(timer);
                this.verificationCode = "获取验证码";
                this.status = true;
              } else {
                count--;
                this.verificationCode = count + "s后重新获取";
              }
            }, 1000);
          }
        } else {
          Toast({
            message: data.message,
            className: 'notice',
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getVerifyCode() { //验证短信验证码是否正确
      try {
        let param = {
          "mobile": this.mobile,
          "mobileCode": this.refereeName,
        }
        let {
          data
        } = await getVerifyCode(param);
        if (data.code == 1000) {
          this.landingPageInsert();
          this.authCodeBounced = true; //关闭验证码弹框
        } else {
          Toast({
            message: data.message,
            className: 'notice',
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    //提交数据
    submitData() {
      this.getVerifyCode() //验证验证码是否正确
    },
    async landingPageInsert() {
      try {
        let params = {
          name: this.name,
          mobile: this.mobile,
          json: JSON.stringify({最高学历: this.degree, 职位: this.position}),
          channelCode: 1,
          type: 2,
        }
        let {
          data
        } = await landingPageInsert(params);
        if (data.code == 1000) {
          this.authCodeBounced = false;
          Toast({
            message: "保存成功！",
            className: 'notice',
          });
          var others = {  //这个参数必须是对象
            最高学历: $('#degree').val(),
            职位: $('#position').val(),
          };
          sendPage($('#tel').val(), $('#name').val(), others, {});
          this.$parent.getConversion();
          //清空数据
          this.mobile = "";
          this.name = "";
          this.position = "";
          this.degree = "";
        } else {
          Toast({
            message: data.message,
            className: 'notice',
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    applyClick() {
      if (this.name == "") {
        Toast({
          message: '请填写您的姓名！',
          className: 'notice',
        });
      } else if (this.mobile == "") {
        Toast({
          message: '请填写您的电话！',
          className: 'notice',
        });
      } else if (this.degree == "") {
        Toast({
          message: '请填写您的学历！',
          className: 'notice',
        });
      } else if (this.degree == "") {
        Toast({
          message: '请填写您的职位！',
          className: 'notice',
        });
      } else {
        this.authCodeBounced = true; //打开验证码弹框
        this.getRegisterCode(); //获取验证码
      }
    },
  },
  mounted() {
  }
}
</script>
<style scoped>
.questionBox {
  padding-bottom: 32px;
  box-sizing: border-box;
  position: relative;
}

.question-item {
  width: calc(100% - 80px);
  box-sizing: border-box;
  margin: 40px auto;
}

.exam-top span {
  color: #FF6F27;
  font-size: 30px;
}

/*input*/
.label-input {
  font-size: 36px;
  color: #666;
  line-height: 80px;
}

.input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #ccc;
  height: 60px;

}

.item .mint-cell {
  border-bottom: 1px solid #ccc;
}

.question-item >>> .mint-cell-wrapper {
  flex-wrap: wrap;
  background-image: none;
}

.question-item >>> .mint-field-core {
  font-size: 28px;
}

.question-item >>> .mint-cell-title {
  width: 100%;
  font-size: 36px;
  color: #666;
  line-height: 80px;
}

.question-item >>> .mintui {
  font-size: 32px;
}

.question-item >>> .mint-cell-value {
  flex: none;
  width: 100%;
}

/* 单选 */
.question-title {
  font-size: 36px;
  color: #666;
  line-height: 80px;
}

.item {
  margin-bottom: 40px;
}

.item-input-cont {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 40px;
}

.label {
  width: 48%;
  font-size: 30px;
  margin-bottom: 50px;
  margin-left: 10px;
  color: #444;
  font-size: 34px;
  line-height: 50px;
}

input[type='radio'] {
  background-color: #FF6F27;
  border-color: #FF6F27;
}

.btn {
  width: calc(100% - 200px);
  padding: 20px;
  display: block;
  margin: 0 auto;
  border: none;
  border-radius: 50px;
  font-size: 36px;
  font-weight: bold;
}

/*手机验证码弹框*/
.auth-code {
  width: 100%;
}

.auth-code .mint-popup {
  width: 80%;
  margin: 0 auto;
  padding: 40px;
  border-radius: 15px;
  text-align: center;
}

.auth-code .mint-popup h2 {
  margin-bottom: 20px;
  font-size: 32px;
  color: #333;
  font-weight: 400;
}

.auth-code .mint-popup span {
  margin-bottom: 50px;
  font-size: 24px;
  color: #ccc;
  display: block;
}

.get-code {
  width: 100%;
  height: 70px;
  border: 1px solid #ececec;
  margin-bottom: 40px;
}

.verification-code {
  position: absolute;
  right: 10px;
  top: 20px;
}

.code-cont {
  position: relative;
}

input {
  text-indent: 10px;
}


</style>
<style>
.notice {
  /*font-size: 28px !important;*/
  transform: scale(1.5) !important;
  margin-left: -1.3rem !important;
  z-index: 999999;
}
.minimizeBoxMinimalism{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/bbsH5/pubForm.vue